import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { DataSource } from '@angular/cdk/collections';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';

import { OpcionModel } from '../Global/Opcion.model';
import { FacturacionElectronicaConsultarModel } from './FacturacionElectronicaConsultarLogModel';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { MatSnackBar } from '@angular/material';
import { IfObservable } from 'rxjs/observable/IfObservable';


@Component({
	selector: 'consultarLog',
	templateUrl: './ConsultarLog.component.html',
	styleUrls: ['../../../../styles.css']
})

/**
* @author Camilo
* @since  01/10/2018
**/
export class FacturacionElectronicaConsultarLogComponent {

	public form: FormGroup;
	public formErrors: any;

	public prefijo: string;
	public numero: string;
	public negocio: string;

	myControl = new FormControl();
	filteredOptions: Observable<OpcionModel[]>;

	public dataDataBase: NegociosDatabase;
	public dataSource: ExampleDataSource;

	public btnConsultar: boolean;
	public cargando: boolean = false;
	public render: boolean = false;

	public ocultar: boolean = false;
	public mensaje: string = "";

	public displayedColumns = ['DPROCESSDATE', 'hora', 'VPROCESSNAME', 'VPROCESSSTATUS', 'VERRORMESSAGE', 'VLEGALSTATUS', 'VGOVERNMENTRESPONSECODE'];


	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog) {

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();


	}


	ngOnInit() {
		this.inicializarForm();
	}



	inicializarForm() {
		this.formErrors = {
			prefijo: {},
			numero: {},
			negocio: {}
		};


		this.form = this.formBuilder.group({
			prefijo: [''],
			numero: ['', Validators.required],
			negocio: ['', Validators.required]
		});
	}





	onFormValuesChanged() {
		for (const field in this.formErrors) {
			if (!this.formErrors.hasOwnProperty(field)) {
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if (control && control.dirty && !control.valid) {
				this.formErrors[field] = control.errors;
			}
		}
	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}

	consultar() {

		this.cargando = true;
		this.render = false;
		this.dataDataBase = new NegociosDatabase();
		let parametros = { prefijo: this.prefijo, numero: this.numero, negocio: this.negocio };
		this._serviciosGenerales.get('servicioFacturacionElectronica/consultarLog', parametros).subscribe(
			result => {
				console.log(result);
				if (result.error != undefined && result.error == true) {
					this.openSnackBarEspecial(result.mensaje, "X");
				} else {
					this.render = true;

					for (let x = 0; x < result.length; x++) {
						let temp = result[x];
						console.log(temp);
						let log = new FacturacionElectronicaConsultarModel(temp.DPROCESSDATE, temp.hora, temp.VPROCESSNAME, temp.VPROCESSSTATUS, temp.VERRORMESSAGE, temp.VLEGALSTATUS, temp.VGOVERNMENTRESPONSECODE)
						console.log(log);
						this.dataDataBase.addNegocio(log);
					}
				}
				this.cargando = false;
				this.dataSource = new ExampleDataSource(this.dataDataBase);

			}, error => {
				this.cargando = false;
				console.log(error);
			}
		)

	}



}


// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

export class NegociosDatabase {

	dataChange: BehaviorSubject<FacturacionElectronicaConsultarModel[]> = new BehaviorSubject<FacturacionElectronicaConsultarModel[]>([]);

	get data(): FacturacionElectronicaConsultarModel[] {
		return this.dataChange.value;
	}

	addNegocio(log: FacturacionElectronicaConsultarModel) {
		const copiedData = this.data.slice();
		copiedData.push(log);
		this.dataChange.next(copiedData);
	}

}

export class ExampleDataSource extends DataSource<any>
{
	_filterChange = new BehaviorSubject('');

	get filter(): string {
		return this._filterChange.value;
	}

	set filter(filter: string) {
		this._filterChange.next(filter);
	}

	constructor(private _exampleDatabase: NegociosDatabase) {
		super();
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<FacturacionElectronicaConsultarModel[]> {
		const displayDataChanges = [
			this._exampleDatabase.dataChange,
			this._filterChange
		];

		return Observable.merge(...displayDataChanges).map(() => {
			return this._exampleDatabase.data.slice().filter((item: FacturacionElectronicaConsultarModel) => {
				let searchStr = (item.VPROCESSNAME).toLowerCase();
				return searchStr.indexOf(this.filter.toLowerCase()) != -1;
			});
		});
	}

	disconnect() {
	}
}



// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/FacturacionElectronicaConsultarLog/FacturacionElectronicaConsultarLog.component.ts